export function safeJsonParse<T>(
  jsonString: string | null,
  defaultValue: T
): T {
  if (jsonString === null) {
    return defaultValue;
  }

  try {
    return JSON.parse(jsonString);
  } catch {
    // If parsing fails, return the string itself or the defaultValue
    return defaultValue;
  }
}

/**
 * Parses a JSON array string into a string array, defensively. Returns []
 * for empty/invalid input or if the parsed value isn't an array.
 */
export function parseStringArray(
  jsonString: string | null | undefined
): string[] {
  if (!jsonString) return [];
  const parsed = safeJsonParse<unknown>(jsonString, []);
  return Array.isArray(parsed) ? parsed.map((v) => `${v}`) : [];
}
